/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBloodDonation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.198 4.715A5.693 5.693 0 0 1 16.26 3c1.529 0 2.99.62 4.064 1.714A5.872 5.872 0 0 1 22 8.828a5.91 5.91 0 0 1-.352 2.013l-.008.02-.215.52-1.848-.763.197-.478A3.91 3.91 0 0 0 20 8.828a3.872 3.872 0 0 0-1.101-2.713A3.694 3.694 0 0 0 16.261 5c-.984 0-1.932.399-2.636 1.115L12 7.773l-1.627-1.657a3.675 3.675 0 0 0-5.272 0c-1.468 1.495-1.468 3.93 0 5.427l7.612 7.757-1.427 1.4-7.612-7.757c-2.232-2.274-2.232-5.954 0-8.228a5.675 5.675 0 0 1 8.126 0l.199.202zm5.306 6.012.62.488c.634.5 1.564 1.366 2.345 2.351a9.146 9.146 0 0 1 1.04 1.601c.27.546.479 1.165.485 1.803.04.783-.12 1.934-.757 2.953-.676 1.084-1.853 1.953-3.665 2.075l-.034.002h-.034c-.77 0-1.932-.267-2.893-1.038-1.016-.816-1.732-2.136-1.594-4.034.098-1.353.924-3.393 3.868-5.713zm-.01 2.58c-2.08 1.82-2.44 3.18-2.482 3.765-.091 1.254.356 1.933.85 2.33.537.43 1.214.59 1.611.598 1.13-.086 1.726-.588 2.067-1.135.378-.606.483-1.34.456-1.807l-.002-.029V17c0-.227-.079-.544-.278-.948a7.178 7.178 0 0 0-.814-1.243 13.412 13.412 0 0 0-1.408-1.502z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBloodDonation as BloodDonation };
